import { ButtonHTMLAttributes } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { Size } from "../../constants/enum";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string | React.ReactElement;
  icon?: React.ReactElement;
  color?: "pink" | "gray";
  size?: Size;
  variant?: "outlined" | "text";
}

function CommonButton({
  text,
  icon,
  color = "pink",
  size = Size.Medium,
  variant,
  className,

  ...rest
}: IProps) {
  return (
    <button
      className={classNames("btn", `${className ? className : ""}`, {
        [styles.pinkBtn]: color === "pink",
        [styles.grayBtn]: color === "gray",
        [styles.mediumBtn]: size === "medium",
        [styles.smallBtn]: size === "small",
        [styles.fullWidthBtn]: size === "full-width",
        [styles.outlinedBtn]: variant === "outlined",
        [styles.textBtn]: variant === "text",
        [styles.disabled]: rest.disabled,
      })}
      {...rest}
    >
      <div>
        <span> {text}</span>
        {icon && <span> {icon}</span>}
      </div>
    </button>
  );
}
export default CommonButton;
